import React from 'react';
import { motion } from 'framer-motion';
import { FiGithub, FiLinkedin, FiMail, FiHeart } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: <FiLinkedin />,
      href: 'https://linkedin.com/in/sonam--singh',
      label: 'LinkedIn',
    },
    {
      icon: <FiGithub />,
      href: 'https://github.com',
      label: 'GitHub',
    },
    {
      icon: <FiMail />,
      href: 'mailto:contact@sonamsingh.com',
      label: 'Email',
    },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <motion.div
            className="footer-brand"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <span className="footer-logo">SS</span>
            <span className="footer-name">Sonam Singh</span>
          </motion.div>

          <motion.div
            className="footer-social"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
          >
            {socialLinks.map((link, index) => (
              <motion.a
                key={index}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                whileHover={{ scale: 1.1, y: -3 }}
                whileTap={{ scale: 0.95 }}
                aria-label={link.label}
              >
                {link.icon}
              </motion.a>
            ))}
          </motion.div>
        </div>

        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <p className="footer-copyright">
            &copy; {currentYear} Sonam Singh. All rights reserved.
          </p>
          <p className="footer-made-with">
            Made with <FiHeart className="heart-icon" /> in Nepal
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
